/* ZAP charts - generic, token-driven data-viz renderer.
   Each chart section renders a native <table data-chart-src> (accessible source of truth) and an empty
   <svg data-chart-svg> inside a [data-zap-chart="donut|histogram"] container. This reader parses
   the table and draws the SVG. Colours come from CSS custom properties (var(--chart-1..7)) so the Zap
   Builder theme settings drive every chart. Defensive: a bad chart never breaks the page. */
(function () {
  "use strict";
  function svgEl(t, a) { var e = document.createElementNS("http://www.w3.org/2000/svg", t); for (var k in a) e.setAttribute(k, a[k]); return e; }
  function txt(el, s) { el.textContent = s; return el; }
  function num(s) { if (s == null) return 0; var n = parseFloat(("" + s).replace(/[^0-9.\-]/g, "")); return isNaN(n) ? 0 : n; }
  var PAL = ["var(--chart-1)", "var(--chart-2)", "var(--chart-3)", "var(--chart-4)", "var(--chart-5)", "var(--chart-6)", "var(--chart-7)"];

  function readRows(container) {
    var t = container.querySelector("table"); if (!t) return [];
    var rows = [];
    t.querySelectorAll("tbody tr").forEach(function (tr) {
      var head = tr.querySelector("th");
      var cells = tr.querySelectorAll("td");
      var label = head ? head.textContent.trim() : (cells[0] ? cells[0].textContent.trim() : "");
      var vals = [], disp = [];
      cells.forEach(function (td) { vals.push(num(td.textContent)); disp.push(td.textContent.trim()); });
      rows.push({ label: label, vals: vals, disp: disp });
    });
    return rows;
  }

  function donut(c, svg, rows) {
    svg.innerHTML = ""; svg.setAttribute("viewBox", "0 0 200 200");
    var total = rows.reduce(function (a, r) { return a + (r.vals[0] || 0); }, 0) || 1;
    var cx = 100, cy = 100, r = 72, sw = 30, C = 2 * Math.PI * r, off = 0;
    svg.appendChild(svgEl("circle", { cx: cx, cy: cy, r: r, fill: "none", stroke: "var(--surface-wash)", "stroke-width": sw }));
    rows.forEach(function (row, i) {
      var len = (row.vals[0] || 0) / total * C;
      svg.appendChild(svgEl("circle", { cx: cx, cy: cy, r: r, fill: "none", stroke: PAL[i % PAL.length], "stroke-width": sw, "stroke-dasharray": len + " " + (C - len), "stroke-dashoffset": -off, transform: "rotate(-90 " + cx + " " + cy + ")" }));
      off += len;
    });
    var big = c.getAttribute("data-center-value") || ("" + Math.round(total));
    svg.appendChild(txt(svgEl("text", { x: cx, y: cy - 2, "text-anchor": "middle", "font-family": "var(--font-display)", "font-weight": "700", "font-size": "28", fill: "var(--brand-primary)" }), big));
    var sub = c.getAttribute("data-center-label");
    if (sub) svg.appendChild(txt(svgEl("text", { x: cx, y: cy + 16, "text-anchor": "middle", "font-size": "11", fill: "var(--text-muted)" }), sub));
    var leg = c.querySelector("[data-chart-legend]");
    if (leg) {
      leg.innerHTML = "";
      rows.forEach(function (row, i) {
        var li = document.createElement("li");
        var sw2 = document.createElement("span"); sw2.className = "sw"; sw2.style.background = PAL[i % PAL.length]; li.appendChild(sw2);
        var nm = document.createElement("span"); nm.textContent = row.label; li.appendChild(nm);
        var pc = document.createElement("span"); pc.className = "pc"; pc.textContent = row.disp[0] || ((row.vals[0] / total * 100).toFixed(1) + "%"); li.appendChild(pc);
        leg.appendChild(li);
      });
    }
  }

  function histogram(c, svg, rows) {
    svg.innerHTML = ""; svg.setAttribute("viewBox", "0 0 620 300");
    var W = 620, H = 300, ml = 44, mr = 16, mt = 18, mb = 54, pw = W - ml - mr, ph = H - mt - mb;
    var maxV = Math.max.apply(null, rows.map(function (r) { return r.vals[0] || 0; })) || 1;
    var n = rows.length || 1, gap = pw / n, bw = gap * 0.6;
    for (var g = 0; g <= 4; g++) {
      var yy = mt + ph - ph * (g / 4);
      svg.appendChild(svgEl("line", { x1: ml, y1: yy, x2: ml + pw, y2: yy, stroke: "var(--chart-grid)", "stroke-width": 1 }));
    }
    rows.forEach(function (row, i) {
      var x = ml + gap * i + (gap - bw) / 2, bh = ph * ((row.vals[0] || 0) / maxV), y = mt + ph - bh;
      svg.appendChild(svgEl("rect", { x: x, y: y, width: bw, height: bh, rx: 5, fill: i === 0 ? "var(--chart-1)" : "var(--chart-2)" }));
      svg.appendChild(txt(svgEl("text", { x: x + bw / 2, y: y - 7, "text-anchor": "middle", "font-size": "10.5", "font-weight": "600", fill: "var(--text-strong)" }), row.disp[0] || ""));
      svg.appendChild(txt(svgEl("text", { x: x + bw / 2, y: mt + ph + 18, "text-anchor": "middle", "font-size": "11", fill: "var(--text-muted)" }), row.label));
    });
    var xl = c.getAttribute("data-x-label");
    if (xl) svg.appendChild(txt(svgEl("text", { x: ml + pw / 2, y: H - 6, "text-anchor": "middle", "font-size": "11", "font-weight": "600", fill: "var(--text-muted)" }), xl));
  }

  var DRAW = { donut: donut, histogram: histogram };
  function drawAll() {
    document.querySelectorAll("[data-zap-chart]").forEach(function (c) {
      try {
        var type = c.getAttribute("data-zap-chart");
        var svg = c.querySelector("svg[data-chart-svg]");
        var rows = readRows(c);
        if (svg && rows.length && DRAW[type]) DRAW[type](c, svg, rows);
      } catch (e) { /* keep the page alive; the data table below remains the accessible source */ }
    });
  }
  function drawIn(root) {
    if (!root || !root.querySelectorAll) return drawAll();
    root.querySelectorAll("[data-zap-chart]").forEach(function (c) {
      try {
        var type = c.getAttribute("data-zap-chart");
        var svg = c.querySelector("svg[data-chart-svg]");
        var rows = readRows(c);
        if (svg && rows.length && DRAW[type]) DRAW[type](c, svg, rows);
      } catch (e) { /* keep the page alive */ }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", drawAll); else drawAll();
  // Theme editor: sections are injected/re-rendered without a page reload, so redraw on Shopify's events.
  document.addEventListener("shopify:section:load", function (e) { drawIn(e.target); });
  document.addEventListener("shopify:section:reorder", function () { drawAll(); });
  document.addEventListener("shopify:block:select", function (e) { drawIn(e.target.closest ? e.target.closest(".shopify-section") : null); });
})();


/* ============================================================================
   Zenyth Chart framework (the znt-chart block: donut / progress / bars / clusters).
   Reads slice data-* from the DOM, draws the chosen chart, wires the hover tooltip,
   builds the accessible data table, and re-animates on scroll-into-view. One instance,
   defined once, scans every [data-znt-chart] on the page.
   ============================================================================ */
(function () {
    if (window.__zntChart) { window.__zntChart.init(); return; }
    var NS = 'http://www.w3.org/2000/svg';
    function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function fmt(n) { return Math.round(n).toLocaleString('en-US'); }

    function buildOne(root) {
      if (root.__zntBuilt) return;
      root.__zntBuilt = true;
      var type = root.getAttribute('data-znt-chart-type') || 'donut';
      var showLabel = root.getAttribute('data-show-label') !== 'false';
      var showNum = root.getAttribute('data-show-value') !== 'false';
      var asPercent = root.getAttribute('data-value-percent') === 'true';
      // Per-instance opt-out of all hover feedback (tooltip + dimming). Set on charts whose values are
      // already fully visible as text, so the hover adds nothing (De'Shan 2026-08-06).
      var noHover = root.getAttribute('data-znt-disable-hover') === 'true';
      var legend = root.querySelector('[data-znt-chart-legend]');
      var body = root.querySelector('.znt-chart__body');
      var tableWrap = root.querySelector('[data-znt-chart-table]');
      var tip = root.querySelector('[data-znt-chart-tip]');
      var toggle = root.querySelector('[data-znt-chart-toggle]');
      if (!legend || !body) return;

      var items = Array.prototype.slice.call(legend.querySelectorAll('.znt-chart__item'));
      var data = items.map(function (li) {
        return { cat: li.getAttribute('data-category') || '', val: parseFloat(li.getAttribute('data-share')) || 0, color: li.getAttribute('data-color') || '#6941C6', vlabel: li.getAttribute('data-value-label') || '', el: li };
      }).filter(function (d) { return d.val > 0; });
      if (!data.length) return;

      var total = data.reduce(function (s, d) { return s + d.val; }, 0) || 1;
      var maxV = data.reduce(function (m, d) { return Math.max(m, d.val); }, 0) || 1;
      var rulesTotal = parseFloat(root.getAttribute('data-znt-chart-total'));
      var hasRules = type === 'donut' && !isNaN(rulesTotal) && rulesTotal > 0;

      var totalSq = parseInt(root.getAttribute('data-znt-chart-squares'), 10) || 200;
      var col2Label = 'Value', unit = '', amountOf = function (d) { return Math.round(d.val); };
      if (hasRules) { col2Label = 'Rules'; unit = 'rules'; amountOf = function (d) { return Math.round(d.val / total * rulesTotal); }; }
      else if (type === 'clusters') { col2Label = 'Squares'; unit = 'squares'; amountOf = function (d) { return Math.round(d.val / total * totalSq); }; }
      function pctOf(d) { return (d.val / total * 100).toFixed(1) + '%'; }
      function numText(d) { if (d.vlabel) return d.vlabel; return asPercent ? pctOf(d) : amountOf(d).toLocaleString('en-US'); }
      function labelText(d) { return showLabel ? esc(d.cat) : ''; }
      function valText(d) { return showNum ? esc(numText(d)) : ''; }
      function showTip(d) {
        if (noHover || !tip) return;
        cancelHide();
        tip.innerHTML = asPercent
          ? '<strong>' + esc(d.cat) + '</strong><span>' + pctOf(d) + '</span>'
          : '<strong>' + esc(d.cat) + '</strong><span>' + amountOf(d).toLocaleString('en-US') + (unit ? ' ' + unit : '') + '</span><span>' + pctOf(d) + '</span>';
        tip.setAttribute('aria-hidden', 'false'); tip.classList.add('is-visible');
      }
      function moveTip(e) { if (tip && body) { var r = body.getBoundingClientRect(); tip.style.left = (e.clientX - r.left) + 'px'; tip.style.top = (e.clientY - r.top) + 'px'; } }
      function hideTip() { if (tip) { tip.classList.remove('is-visible'); tip.setAttribute('aria-hidden', 'true'); } }
      // WCAG 1.4.13 Hoverable: the tooltip is triggered by hovering a square, but it must stay long enough
      // for the pointer to travel onto it and remain while the pointer is over it. So hideTip is DEFERRED
      // (leaving a square schedules a hide instead of hiding at once), entering the tooltip cancels the
      // pending hide, and re-entering another square cancels it too (showTip -> cancelHide). Paired with
      // the CSS bridge (.znt-chart__tooltip::after) that fills the gap and pointer-events:auto-while-visible.
      var hideTimer = null;
      function cancelHide() { if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; } }
      function scheduleHide() { cancelHide(); hideTimer = setTimeout(hideTip, 260); }
      if (tip) {
        tip.onmouseenter = cancelHide;
        tip.onmouseleave = scheduleHide;
        // WCAG 1.4.13 Dismissible: Esc hides the tooltip without moving the pointer (it can obscure the
        // adjacent squares). It only re-shows on a fresh hover, so a stationary pointer keeps it dismissed.
        document.addEventListener('keydown', function (e) {
          if ((e.key === 'Escape' || e.key === 'Esc') && tip.classList.contains('is-visible')) { cancelHide(); hideTip(); }
        });
      }

      var animate = { draw: function () {}, reset: function () {} };

      if (type === 'donut') {
        var svg = root.querySelector('[data-znt-chart-svg]'); if (!svg) return; svg.innerHTML = '';
        var R = 42, CX = 50, CY = 50, C = 2 * Math.PI * R;
        var thickness = parseFloat(getComputedStyle(root).getPropertyValue('--znt-chart-donut-thickness')) || 15;
        var circles = [], cum = 0;
        data.forEach(function (d, i) {
          var arc = (d.val / total) * C;
          var seg = document.createElementNS(NS, 'circle');
          seg.setAttribute('cx', CX); seg.setAttribute('cy', CY); seg.setAttribute('r', R);
          seg.setAttribute('fill', 'none'); seg.setAttribute('stroke', d.color); seg.setAttribute('stroke-width', thickness);
          seg.setAttribute('stroke-dasharray', arc + ' ' + (C - arc));
          seg.setAttribute('transform', 'rotate(' + (-90 + (cum / total) * 360) + ' ' + CX + ' ' + CY + ')');
          seg.setAttribute('class', 'znt-chart__seg');
          seg.style.strokeDashoffset = arc;
          seg.style.transition = 'stroke-dashoffset .9s cubic-bezier(.22,1,.36,1) ' + (i * 0.08) + 's';
          seg.__arc = arc;
          seg.onmouseenter = function (e) { showTip(d); moveTip(e); dim(i, true); };
          seg.onmousemove = moveTip;
          seg.onmouseleave = function () { scheduleHide(); dim(i, false); };
          svg.appendChild(seg); circles.push(seg); cum += d.val;
        });
        data.forEach(function (d) {
          var catEl = d.el.querySelector('.znt-chart__cat'); if (catEl) catEl.style.display = showLabel ? '' : 'none';
          if (showNum && !d.el.querySelector('.znt-chart__legpct')) { var s = document.createElement('span'); s.className = 'znt-chart__legpct'; s.textContent = numText(d); d.el.appendChild(s); }
        });
        data.forEach(function (d, i) { d.el.onmouseenter = function () { dim(i, true); }; d.el.onmouseleave = function () { dim(i, false); }; });
        function dim(idx, on) { if (noHover) return; circles.forEach(function (c, j) { c.style.opacity = (on && j !== idx) ? '0.8' : '1'; }); data.forEach(function (d, j) { d.el.classList.toggle('is-dim', on && j !== idx); }); }
        animate.draw = function () { void svg.getBoundingClientRect(); circles.forEach(function (c) { c.style.strokeDashoffset = 0; }); };
        animate.reset = function () { circles.forEach(function (c) { c.style.strokeDashoffset = c.__arc; }); };

      } else if (type === 'progress') {
        var plot = root.querySelector('[data-znt-chart-plot]'); if (!plot) return; plot.innerHTML = '';
        var fills = [];
        data.forEach(function (d, i) {
          var row = document.createElement('div'); row.className = 'znt-chart__prow';
          row.style.gridTemplateColumns = (showLabel ? 'minmax(90px,150px) ' : '') + '1fr' + (showNum ? ' auto' : '');
          row.innerHTML = (showLabel ? '<span class="znt-chart__plabel">' + labelText(d) + '</span>' : '') + '<div class="znt-chart__ptrack"><div class="znt-chart__pfill" style="background:' + d.color + '"></div></div>' + (showNum ? '<span class="znt-chart__pval">' + valText(d) + '</span>' : '');
          var fill = row.querySelector('.znt-chart__pfill'); fill.__w = (d.val / maxV * 100) + '%';
          row.onmouseenter = function (e) { showTip(d); moveTip(e); dim(i, true); };
          row.onmousemove = moveTip;
          row.onmouseleave = function () { scheduleHide(); dim(i, false); };
          plot.appendChild(row); fills.push({ fill: fill, row: row });
        });
        // A11y (ZAP 2026-07-31 CL-DESHAN): the progress plot is aria-hidden and the data legend is
        // display:none, so a screen reader gets nothing. Expose the full label+value data as the chart's
        // accessible name (role=img). Visual is unchanged.
        try {
          var psummary = data.map(function (d) { var lbl = (d.cat || '').trim(); var v = numText(d); return lbl ? (lbl + ': ' + v) : v; }).filter(Boolean).join('; ');
          if (psummary) { root.setAttribute('role', 'img'); root.setAttribute('aria-label', psummary); }
        } catch (e) { }
        function dim(idx, on) { if (noHover) return; fills.forEach(function (f, j) { f.row.classList.toggle('is-dim', on && j !== idx); }); }
        animate.draw = function () { fills.forEach(function (f) { void f.fill.offsetWidth; f.fill.style.width = f.fill.__w; }); };
        animate.reset = function () { fills.forEach(function (f) { f.fill.style.width = '0%'; }); };

      } else if (type === 'clusters') {
        var plotC = root.querySelector('[data-znt-chart-plot]'); if (!plotC) return; plotC.innerHTML = '';
        var grid = document.createElement('div'); grid.className = 'znt-chart__waffle';
        var alloc = data.map(function (d) { var raw = d.val / total * totalSq; var base = Math.floor(raw); return { d: d, base: base, frac: raw - base }; });
        var rem = totalSq - alloc.reduce(function (s, a) { return s + a.base; }, 0);
        alloc.slice().sort(function (a, b) { return b.frac - a.frac; }).forEach(function (a, i) { if (i < rem) a.base += 1; });
        var cells = [], n = 0;
        alloc.forEach(function (a, ci) {
          for (var k = 0; k < a.base; k++) {
            var cell = document.createElement('span'); cell.className = 'znt-chart__cell'; cell.style.background = a.d.color;
            cell.style.transitionDelay = (n * 6) + 'ms'; cell.__idx = ci; n++;
            cell.onmouseenter = function (e) { showTip(a.d); moveTip(e); };
            cell.onmousemove = moveTip;
            cell.onmouseleave = function () { scheduleHide(); };
            grid.appendChild(cell); cells.push(cell);
          }
        });
        plotC.appendChild(grid);
        data.forEach(function (d, i) {
          var catEl = d.el.querySelector('.znt-chart__cat'); if (catEl) catEl.style.display = showLabel ? '' : 'none';
          if (showNum && !d.el.querySelector('.znt-chart__legpct')) { var s = document.createElement('span'); s.className = 'znt-chart__legpct'; s.textContent = numText(d); d.el.appendChild(s); }
        });
        // Cross-highlight (hover a legend item to dim the other grid cells, or hover a cell to dim the
        // other legend items) removed 2026-08-07 (De'Shan): it was mouse-only, not keyboard-operable, and
        // the values are already shown in the visible legend. The hover tooltip is unchanged.
        animate.draw = function () { void grid.offsetWidth; cells.forEach(function (c) { c.classList.add('is-in'); }); };
        animate.reset = function () { cells.forEach(function (c) { c.classList.remove('is-in'); }); };

      } else { // bars (vertical)
        var plotB = root.querySelector('[data-znt-chart-plot]'); if (!plotB) return; plotB.innerHTML = '';
        var wrap = document.createElement('div'); wrap.className = 'znt-chart__bars';
        var bars = [];
        data.forEach(function (d, i) {
          var col = document.createElement('div'); col.className = 'znt-chart__bcol';
          col.innerHTML = (showNum ? '<div class="znt-chart__bval">' + valText(d) + '</div>' : '') + '<div class="znt-chart__bwrap"><div class="znt-chart__bar" style="background:' + d.color + '"></div></div>' + (showLabel ? '<div class="znt-chart__bcat">' + labelText(d) + '</div>' : '');
          var bar = col.querySelector('.znt-chart__bar'); bar.__h = (d.val / maxV * 100) + '%';
          col.onmouseenter = function (e) { showTip(d); moveTip(e); dim(i, true); };
          col.onmousemove = moveTip;
          col.onmouseleave = function () { scheduleHide(); dim(i, false); };
          wrap.appendChild(col); bars.push({ bar: bar, col: col });
        });
        plotB.appendChild(wrap);
        function dim(idx, on) { if (noHover) return; bars.forEach(function (b, j) { b.col.classList.toggle('is-dim', on && j !== idx); }); }
        animate.draw = function () { bars.forEach(function (b) { void b.bar.offsetHeight; b.bar.style.height = b.bar.__h; }); };
        animate.reset = function () { bars.forEach(function (b) { b.bar.style.height = '0%'; }); };
      }

      if (tableWrap) {
        var sum2 = 0;
        var rows = data.map(function (d) {
          var v = amountOf(d); sum2 += v;
          return '<tr><td><span class="znt-chart__swatch" style="background:' + d.color + '" aria-hidden="true"></span>' + esc(d.cat) + '</td><td>' + v.toLocaleString('en-US') + '</td><td>' + pctOf(d) + '</td></tr>';
        }).join('');
        tableWrap.innerHTML = '<table class="znt-chart__data"><thead><tr><th scope="col">Category</th><th scope="col">' + col2Label + '</th><th scope="col">Share</th></tr></thead><tbody>' + rows + '</tbody><tfoot><tr><th scope="row">Total</th><td>' + sum2.toLocaleString('en-US') + '</td><td>100.0%</td></tr></tfoot></table>';
      }

      if (toggle && tableWrap) {
        toggle.onclick = function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) { tableWrap.setAttribute('hidden', ''); } else { tableWrap.removeAttribute('hidden'); }
        };
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Draw immediately so a chart is NEVER stuck hidden (e.g. if the observer never crosses its
      // threshold). The observer below only re-plays the entrance animation on scroll.
      animate.draw();
      if (reduce) { return; }
      // Scroll re-play (re-animating the entrance every time the chart re-enters view) is OFF by default:
      // the chart draws once above and stays. It is kept ONLY where data-znt-scroll-replay="on" (compliance
      // pages, gated in znt-chart.liquid via `template contains 'compliance'`). De'Shan, 2026-07-15.
      var scrollReplay = root.getAttribute('data-znt-scroll-replay') === 'on';
      if (scrollReplay && 'IntersectionObserver' in window) {
        if (root.__zntIO) { root.__zntIO.disconnect(); }
        var seen = false;
        root.__zntIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { seen = true; animate.draw(); }
            else if (seen) { animate.reset(); } // only collapse AFTER it has been seen, so a chart is never left hidden
          });
        }, { threshold: 0 });
        root.__zntIO.observe(root);
      }
    }

    function initAll(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-znt-chart]'), buildOne); }
    function rebuild(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-znt-chart]'), function (r) { r.__zntBuilt = false; if (r.__zntIO) { r.__zntIO.disconnect(); } buildOne(r); }); }

    window.__zntChart = { init: initAll, rebuild: rebuild };
    document.addEventListener('shopify:section:load', function (e) { rebuild(e.target); });
    document.addEventListener('shopify:block:select', function (e) { rebuild(e.target); });
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { initAll(); }); } else { initAll(); }
  })();
